<template>
	<div class="transport_xunjia">
		<el-form :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<el-row>
				<el-col :span="24">
					<transportmain :ref="'createtransport_main_'+l_id" :item="item"
						@transportmainrollback="transportmainrollback" :title="createtransport_lang.baseinfo" 
						:isdetail="isdetail">
					</transportmain>
				</el-col>
			</el-row>
			<el-row  v-if="isshowcargo">
				<el-col :span="24">
					<gridlist :ref="'createtransport_cargolist_'+l_id" :item="item" :isdetail="isdetail" 
					:title="createtransport_lang.cargolisttitle"></gridlist>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<transportmain :ref="'createtransport_peicang_'+l_id" :item="item"
						@transportmainrollback="transportmainrollback" :title="createtransport_lang.peicang"
						 :isdetail="isdetail">
					</transportmain>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<transportmain :ref="'createtransport_tidan_'+l_id" :item="item"
						@transportmainrollback="transportmainrollback" :title="createtransport_lang.tidan" 
						:isdetail="isdetail">
					</transportmain>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<transportmain :ref="'createtransport_other_'+l_id" :item="item"
						@transportmainrollback="transportmainrollback" :title="createtransport_lang.remarktitle" 
						:isdetail="isdetail">
					</transportmain>
				</el-col>
			</el-row>
			<!-- <el-row>
				<el-col :span="24">
					<feelist :ref="'createtransport_ys_'+l_id" :item="item" :title="createtransport_lang.ystitle" :copyfeetitle="createtransport_lang.copyysfee" :copyitem="true" @feehandler="feehandler" feetype="1"></feelist>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<feelist :ref="'createtransport_yf_'+l_id" :item="item" :title="createtransport_lang.yftitle" :copyfeetitle="createtransport_lang.copyyffee" :copyitem="true" @feehandler="feehandler" feetype="2"></feelist>
				</el-col>
			</el-row> -->
			<el-row  style="margin-bottom:25px;">
				<el-col :span="24">
					<transportmain :ref="'createtransport_nb_'+l_id" :item="item"
						@transportmainrollback="transportmainrollback" :title="createtransport_lang.nbtitle" :isdetail="isdetail">
					</transportmain>
				</el-col>
			</el-row>
		</el-form>
		<el-row v-if="!btnhidden&&!isdetail" class="footerhandler">
			<el-col :span="5" class="submitBtn_switch" style="text-align: right;color:transparent">1</el-col>
			<el-col :span="4" class="submitBtn">
				<div @click="saveorder">{{$lang.label.public.savebtn}}</div>
			</el-col>
			<el-col :span="4" class="submitBtn_cancel">
				<div @click="cancel">{{$lang.label.public.cancel}}</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import Utils from '../../lib/util.js';
	import handlerbtn from '@/components/handlerbutton/handlerbtn.vue';
	import transportmain from '@/components/transport/transportmain.vue';
	//import feelist from '@/components/transport/feelist.vue';
	import gridlist from '@/components/tools/gridlist.vue'
	export default {
		components: {
			handlerbtn,
		//	feelist,
			transportmain,
			gridlist
		},
		props: {
			item: {
				type: Object,
				default: function() {
					return {

					};
				}
			},
			l_id: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				createtransport_lang: {},
				windowHeight: window.innerHeight - 120,
				checkedpmode: '',
				btnhidden: false,
				t_id: '',
				type: '集运订单',
				orderinfo:'',
				p_pkval:'',
				divclass:'transport_xunjia',
				isdetail:false,
				isshowcargo:false,
				t_syscol:''
				//pagetranscol:{}
			}
		},
		methods() {
			import('../../static/' + this.$theme + '/style/transport.scss');
			//this.init();
		},
		methods: {
			//获取业务类型
			transportmainrollback(e) {
				//debugger
				var that=this;
				if(e.event=='getbaojia'){
					this.t_id='';
					this.GetOrderInfo('476',e.value);
				}
				
				debugger
				if (e.event == 'change') {
					this.t_id='';
					this.t_syscol='';
					this.isshowcargo=false;
					this.checkedpmode = e.value;
					this.GetPageLayout();
				}
				if(e.event=='getcrmlist'){
					//debugger
					this.$refs['createtransport_nb_' + this.l_id].setlist.forEach(b=>{
						if(b.colname==e.colfun)
						{
							b.value=[e.value];
						}	
					});
				}
				if(e.event=='showcargo'){
					that.isshowcargo=e.value;
					//debugger
					if(e.value){//显示商品明细
						this.$nextTick(function() {
							that.$refs['createtransport_cargolist_' + that.l_id].init({
								syscol: that.t_syscol,
								orderinfo: that.orderinfo,
								iscopy: that.iscopy,
								pkval: that.p_pkval,
								t_id: that.t_id,
								p_mode:that.checkedpmode,
								type: that.type+'-cargo-'+that.checkedpmode
							});
						});
					}
				}
			},
			buttoncb(e) {
				//debugger
			},
			init(param) {
				//debugger
				if(param.isdetail!=undefined)
					this.isdetail=param.isdetail;
				var that = this;
				this.$public.GetLanguageByMode(this.type, this).then(res => {
					//debugger
					if (res.state == '1')
						that.createtransport_lang = that.$lang.label[that.type];

					if (param.pkval != undefined) this.p_pkval = param.pkval;
					if (param.iscopy != undefined) this.iscopy = param.iscopy;
					//this.p_pkval='1686097529033';
					if (this.p_pkval != '') {
						this.GetOrderInfo(this.l_id,this.p_pkval);
					} else {
						this.GetPageLayout();
					}
				});
			},
			GetOrderInfo(l_id,pkval){
				var that=this;
				this.$tool.loading(that.$lang.label.public.loading, this.divclass);
				var paraminfo={
					pkval:pkval,
					l_id:l_id
				}
				this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						that.orderinfo = res;
						that.checkedpmode=res.main.p_mode;
						that.GetPageLayout();
					} else
						this.$tool.message(that.$lang.label.public.getinfofailed, "0");
				});
			},
			cancel() {
				//debugger
				Utils.$emit('handleRermove', localStorage.getItem('tabname'));
			},
			GetPageLayout() {
				var that = this;
				//this.truncatepage();
				this.$tool.loading(that.$lang.label.public.loading, this.divclass);
				//判断是哪种类型的下单功能,显示对应组件
				this.$apipost.get.GetTransFormat({
					p_mode: ''
				}).then(res => {
						this.$tool.loadingclose();
						//console.log('组件',res);
						//debugger
						if (res.state == '1') {
							if (res.set != undefined) {
								//debugger
								if(that.checkedpmode!=''){
									if (res.set.t_type == that.type&&res.set.p_mode==that.checkedpmode) 									that.t_id=res.set.t_id;
								}
								
								if (that.t_id!='') {
									//that.t_id = res.set.t_id;
									that.pagetranscol=res.set.pagetranscol;
									that.t_syscol=res.set.t_syscol;
									that.p_mode=res.set.p_mode;
									if (that.orderinfo!='')
										that.orderinfo=that.$tool.TransOrderInfo(res.set.pagetranscol,that);
									this.$nextTick(function() {
											that.$refs['createtransport_main_' + that.l_id].init({
												syscol: res.set.t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: res.set.p_mode,
												type: that.type
											});
											that.$refs['createtransport_peicang_' + that.l_id].init({
												syscol: res.set.t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: res.set.p_mode,
												type: that.type+'-peicang'
											});
											that.$refs['createtransport_tidan_' + that.l_id].init({
												syscol: res.set.t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: res.set.p_mode,
												type: that.type+'-tidan',
											});
											that.$refs['createtransport_other_' + that.l_id].init({
												syscol: res.set.t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: res.set.p_mode,
												type: that.type+'-other',
											});
											that.$refs['createtransport_nb_' + that.l_id].init({
												syscol: res.set.t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: res.set.p_mode,
												type: that.type+'-nb',
											});
											
											// that.$refs['createtransport_ys_' + that.l_id].init({
											// 	syscol: res.set.t_syscol,
											// 	orderinfo: that.orderinfo,
											// 	iscopy: that.iscopy,
											// 	pkval: that.p_pkval,
											// 	t_id: that.t_id,
											// 	p_mode: res.set.p_mode,
											// 	type: that.type+'-ysfee',
											// });
											// that.$refs['createtransport_yf_' + that.l_id].init({
											// 	syscol: res.set.t_syscol,
											// 	orderinfo: that.orderinfo,
											// 	iscopy: that.iscopy,
											// 	pkval: that.p_pkval,
											// 	t_id: that.t_id,
											// 	p_mode: res.set.p_mode,
											// 	type: that.type+'-yffee',
											// });
										});
									}
								}
								if (that.t_id == '') {
									var list =[];
									if(that.checkedpmode!='')
									{
										list=res.list.filter(function(re) {
											return re.t_type == that.type&&re.p_mode==that.checkedpmode;
										});
									}else{
										list=res.list.filter(function(re) {
											return re.t_type ==that.type;
										});
									}
									if (list.length > 0) {
										that.t_id = list[0].t_id;
										that.t_syscol=list[0].t_syscol;
										that.p_mode=list[0].p_mode;
										//that.pagetranscol=list[0].pagetranscol;
										//debugger
										if (that.orderinfo!='')
											that.orderinfo=that.$tool.TransOrderInfo(list[0].pagetranscol,that);
										this.$nextTick(function() {
											that.$refs['createtransport_main_' + that.l_id].init({
												syscol: list[0].t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: list[0].p_mode,
												type:that.type
											});
											that.$refs['createtransport_peicang_' + that.l_id].init({
												syscol: list[0].t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: list[0].p_mode,
												type: that.type+'-peicang'
											});
											that.$refs['createtransport_tidan_' + that.l_id].init({
												syscol: list[0].t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: list[0].p_mode,
												type: that.type+'-tidan'
											});
											that.$refs['createtransport_other_' + that.l_id].init({
												syscol: list[0].t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: list[0].p_mode,
												type: that.type+'-other'
											});
											that.$refs['createtransport_nb_' + that.l_id].init({
												syscol: list[0].t_syscol,
												orderinfo: that.orderinfo,
												iscopy: that.iscopy,
												pkval: that.p_pkval,
												t_id: that.t_id,
												p_mode: list[0].p_mode,
												type: that.type+'-nb'
											});
											// that.$refs['createtransport_yf_' + that.l_id].init({
											// 	syscol: list[0].t_syscol,
											// 	orderinfo: that.orderinfo,
											// 	iscopy: that.iscopy,
											// 	pkval: that.p_pkval,
											// 	t_id: that.t_id,
											// 	p_mode: list[0].p_mode,
											// 	type: that.type+'-yffee'
											// });
											// that.$refs['createtransport_ys_' + that.l_id].init({
											// 	syscol: list[0].t_syscol,
											// 	orderinfo: that.orderinfo,
											// 	iscopy: that.iscopy,
											// 	pkval: that.p_pkval,
											// 	t_id: that.t_id,
											// 	p_mode: list[0].p_mode,
											// 	type: that.type+'-ysfee'
											// });
										});
									}
								}
							}
						});
				},
			saveorder() {
					var that=this;
					var orderinfo=this.$tool.getOrderinfo(this.$refs['createtransport_main_'+this.l_id]._data,this.p_no,this);
					if(this.isshowcargo){
						if(orderinfo!='')
							orderinfo=this.$tool.getOrderinfo(this.$refs['createtransport_cargolist_'+this.l_id]._data,this.p_no,this,orderinfo);
					}
					if(orderinfo!='')
						orderinfo=this.$tool.getOrderinfo(this.$refs['createtransport_peicang_'+this.l_id]._data,this.p_no,this,orderinfo);
					if(orderinfo!='')
						orderinfo=this.$tool.getOrderinfo(this.$refs['createtransport_tidan_'+this.l_id]._data,this.p_no,this,orderinfo);
					if(orderinfo!='')
						orderinfo=this.$tool.getOrderinfo(this.$refs['createtransport_other_'+this.l_id]._data,this.p_no,this,orderinfo);
					if(orderinfo!='')
						orderinfo=this.$tool.getOrderinfo(this.$refs['createtransport_nb_'+this.l_id]._data,this.p_no,this,orderinfo);
					if(orderinfo!=''){
						if(this.p_pkval=='')
							orderinfo.u_userid=localStorage.getItem('userid');
						else
							orderinfo.editid=this.p_pkval;
						orderinfo.t_id=that.t_id;
						this.btnhidden=true;
						this.$tool.loading(that.$lang.label.public.saving, this.divclass);
						this.$apipost.post.SaveInfo({ paraminfo: orderinfo }).then(res => {
							this.$tool.loadingclose();
							this.btnhidden=false;
							if (res.state == '1') {
								this.$tool.message(that.$lang.label.public.savesuccess, "1");
								setTimeout(function(){
									that.cancel();
								},1000);
							}
							else
								this.$tool.message(res.message, "0");
								//this.$tool.message(that.createtransport_lang[res.message], "0");
						});
					}
				}
			}
		}
</script>

<style>
</style>